import Vue from 'vue'
import {http} from '../../axios'

const mutationsSubscribeNames = [
  'addFilesToUpload',
  'deleteFileUploaded',
  'setCoverIndex',
  'setCommentFilesUploaded',
  'changePositionFilesUploaded',
  'setLinkFilesUploaded'
]

export default {
  namespaced: true,
  state: {
    muted: false,
    mutationsSubscribeNames,
    sizeLimitMB: 100,
    pendingUpload: false,
    pendingLoad: false,
    pendingDelete: false,
    filesToUpload: [],
    filesUploaded: [],
    coverIndex: 0
  },
  mutations: {
    setMuted(state, value) {
      state.muted = value
    },
    setPendingUpload(state, value) {
      state.pendingUpload = value
    },
    setPendingLoad(state, value) {
      state.pendingLoad = value
    },
    setPendingDelete(state, value) {
      state.pendingDelete = value
    },
    addFilesToUpload(state, files) {
      for (const file of files) {
        const path = window.URL.createObjectURL(file)
        state.filesToUpload.push({
          description: null,
          image: file,
          path,
          type: file.type,
          link: null
        })
      }
    },
    setFilesToUpload(state, files) {
      state.filesToUpload = files || []
    },
    setFilesUploaded(state, files) {
      state.filesUploaded = files || []
    },
    deleteFileToUpload(state, index) {
      state.filesToUpload.splice(index, 1)
    },
    deleteFileUploaded(state, index) {
      state.filesUploaded.splice(index, 1)
    },
    setCoverIndex(state, index) {
      state.coverIndex = index || 0
    },
    setCommentFilesToUpload(state, {index, comment}) {
      Vue.set(state.filesToUpload[index], 'description', comment)
    },
    changePositionFilesToUpload(state, {index, position}) {
      const file = state.filesToUpload.splice(index, 1)[0]

      state.filesToUpload.splice(position, 0, file)
      if (state.coverIndex !== 0 && state.coverIndex === index) {
        state.coverIndex = position
      }
    },
    setCommentFilesUploaded(state, {index, comment}) {
      Vue.set(state.filesUploaded[index], 'description', comment)
    },
    changePositionFilesUploaded(state, {index, position}) {
      const file = state.filesUploaded.splice(index, 1)[0]
      file.position = position

      state.filesUploaded.splice(position, 0, file)
      if (state.coverIndex !== 0 && state.coverIndex === index) {
        state.coverIndex = position
      }
    },
    setLinkFilesToUpload(state, {index, link}) {
      Vue.set(state.filesToUpload[index], 'link', link)
    },
    setLinkFilesUploaded(state, {index, link}) {
      Vue.set(state.filesUploaded[index], 'link', link)
    },
    resetState(state) {
      state.muted = false
      state.filesToUpload = []
      state.filesUploaded = []
      state.coverIndex = 0
    }
  },
  actions: {
    upload({state, commit}, vacancyId) {
      if (!state.muted || !vacancyId || !state.filesToUpload.length) return Promise.resolve('ok')
      const sendData = new FormData()


      sendData.append('vacancy', vacancyId)
      const positionShift = state.filesUploaded.length

      for (let i = 0; i < state.filesToUpload.length; i++) {
        const file = state.filesToUpload[i]
        if (file.description) {
          sendData.append(`images[${i}][description]`, file.description)
        }
        sendData.append(`images[${i}][position]`, i + positionShift)
        sendData.append(`images[${i}][cover]`, state.coverIndex === i ? 1 : 0)
        sendData.append(`images[${i}][image]`, file.image)
        sendData.append(`images[${i}][link]`, file.link || '')
      }

      commit('setPendingUpload', true)
      return http.post(`/api/vacancy/images`, sendData).then(({data}) => {
        commit('setFilesToUpload', [])
        commit('setFilesUploaded', [...state.filesUploaded, ...data.data])
      }).finally(() => {
        commit('setPendingUpload', false)
      })
    },
    deleteFileUploaded({commit}, {vacancyId, index, id}) {
      commit('setPendingDelete', true)

      http.delete(`/api/vacancy/image/${id}?vacancy=${vacancyId}`).then(() => {
        commit('deleteFileUploaded', index)
      }).finally(() => {
        commit('setPendingDelete', false)
      })
    },
    updateFiles({state}, vacancyId) {
      if (!vacancyId || !state.muted) return

      const sendData = {
        vacancy: vacancyId,
        images: []
      }

      state.filesUploaded.forEach((file, index) => {
        const item = {
          id: file.id,
          description: file.description,
          position: index,
          link: file.link || ''
        }

        if (state.coverIndex === index) {
          item.cover = 1
        }

        sendData.images.push(item)
      })

      http.patch(`/api/vacancy/images`, sendData)
    },
    setVacancyValues({commit}, vacancy) {
      commit('setFilesUploaded', vacancy.images)

      let index = vacancy.images.findIndex(image => image.cover)
      index = index === -1 ? 0 : index
      commit('setCoverIndex', index)
      commit('setMuted', false)
    }
  }
}
